import {useState,useEffect, ChangeEvent, useContext} from 'react';
import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Container, Spinner } from 'reactstrap';
import TablaProductosEsperados from './TablaProductosEsperados';
import IngresoProductoEsperado from './IngresoProductoEsperado';
import { Categoria, getProductoVacio, objProductoEsperado } from '../../../interfaces/Sistema';
import AlertService from '../../../services/AlertService';
import CatalogService from '../../../services/CatalogService';
import { CasUserContext } from '../../../services/casUserContext';
const alertaService = new AlertService();
const catalogoService = new CatalogService();


interface opcion{
  value:string,
  label: string,
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Container>{children}</Container>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}



export default function CategoriaProductos(){
  const [categoriasActivas,setCategoriasActivas] = useState<Array<Categoria>>([]);
  const casUserContext = useContext(CasUserContext);
  const token = casUserContext.token;
  const [value, setValue] = React.useState(0);
  const categoriasOpcion:Array<opcion>= Array<opcion>()
  const [productoInicial, setProductoInicial]= useState<objProductoEsperado>(()=>getProductoVacio())

  const fetchData = async () =>{
    try{
         alertaService.showLoading("Cargando Datos..."); 
         await catalogoService.GetCategoriasActivas() 
         .then((data)=>{
            if(data.status.isSuccessfully){
              //console.log(data);
              setCategoriasActivas(data.listData.reverse())
            }
         }) 
         .catch((error) => console.error(error));               
         alertaService.hideLoading();                
    }catch(error){
      console.error('Error:',error);
    }
  };

 useEffect(() => {
    fetchData();
 },[token]);

  categoriasActivas.map((row)=>{
    let opc : opcion={
      value: row.iddecinvcategoria.toString(),
      label: row.nombrecategoria
    }
    if(opc.value!='0'){
      categoriasOpcion.push(opc)
    }
  })
 

 
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Tipo" {...a11yProps(0)} />
          <Tab label="Tipos de productos esperados" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0} >
        <IngresoProductoEsperado productoEsperado={productoInicial} categorias={categoriasOpcion} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TablaProductosEsperados rowsPerPage={[5 ,10, 25, 100]} />
      </CustomTabPanel>
     
    </Box>
  );

}